import { j as r } from "./atoms-v218.js";
import { Slide as _, SlideButton as z, Variant3Wrapper as H, SlidesFullscreen as P, RoundedImageV3 as q, NavigationButton as d, SlideDetailsWrapper as F } from "./atoms-v2819.js";
import { useBreakpoints as G } from "./atoms-v251.js";
import { useState as E, useMemo as s, useCallback as h, useEffect as J } from "react";
import { wrap as K } from "./atoms-v21046.js";
import { Icon as T } from "./atoms-v217.js";
import { ScreenReaderText as Q } from "./atoms-v236.js";
import { SWIPE_THRESHOLD as A, DRAG_ELASTIC as L, SLIDE_TRANSITION as U, SLIDE_VARIANTS as V } from "./atoms-v21045.js";
import { Column as X } from "./atoms-v212.js";
import { Text as y } from "./atoms-v243.js";
import { motion as R } from "./atoms-v2709.js";
import { AnimatePresence as Y } from "./atoms-v2710.js";
const mt = ({
  defaultSelectedSlide: f = void 0,
  handleOnView: x,
  i18n: i,
  isWrappedSlideshow: a = !1,
  slides: t = []
}) => {
  const { current: B } = G(), p = ["small", "medium"].includes(B), [[m, I], v] = E([0, 0]), [j, k] = E(!1), c = s(
    () => a ? K(0, t.length, m) : Math.min(t.length - 1, Math.max(0, m)),
    [a, m, t]
  ), u = h(
    (o) => {
      const e = m + o, N = a ? e : Math.min(t.length - 1, e);
      v([N, o]);
    },
    [a, m, t]
  ), C = h(
    (o) => {
      const e = o.offset.x;
      e > A ? u(-1) : e < -A && u(1);
    },
    [u]
  );
  J(() => {
    if (!f || j)
      return;
    const o = t.findIndex((e) => e.id === f);
    if (o && o !== m) {
      const e = o > c ? 1 : -1;
      v([o, e]), k(!0);
    }
  }, [f, j, c, t, m]);
  const D = s(() => R(_), []), $ = s(() => R(z), []), g = c === 0, l = c === t.length - 1, M = h(() => (t == null ? void 0 : t.length) === 1 ? 0 : a ? 1 : g ? L.start : l ? L.end : 1, [l, g, t, a]), b = s(() => p ? "3/2" : "16/9", [p]), n = t[c];
  return /* @__PURE__ */ r.jsx(H, { children: /* @__PURE__ */ r.jsxs(X, { large: 7, max: 14, medium: 8, small: 4, style: { position: "relative" }, xLarge: 14, children: [
    /* @__PURE__ */ r.jsx(P, { $aspectRatio: b, children: /* @__PURE__ */ r.jsx(Y, { custom: I, initial: !1, mode: "popLayout", children: /* @__PURE__ */ r.jsxs(
      D,
      {
        animate: "active",
        custom: I,
        drag: (t == null ? void 0 : t.length) > 1 ? "x" : !1,
        dragConstraints: { left: 0, right: 0 },
        dragElastic: M(),
        exit: "exit",
        initial: "incoming",
        onDragEnd: (o, e) => C(e),
        transition: U,
        variants: V,
        whileHover: { cursor: t.length > 1 ? "grab" : "default" },
        whileTap: { cursor: t.length > 1 ? "grabbing" : "default" },
        children: [
          /* @__PURE__ */ r.jsx(q, { ...n, aspectRatio: b }),
          x && /* @__PURE__ */ r.jsx(
            $,
            {
              "aria-label": i == null ? void 0 : i.slideButtonAriaLabel,
              onTap: () => x == null ? void 0 : x(n == null ? void 0 : n.id),
              type: "button"
            }
          )
        ]
      },
      m
    ) }) }),
    /* @__PURE__ */ r.jsx(
      d,
      {
        iconOnly: !0,
        $direction: "previous",
        $hidden: !a && g,
        ariaLabel: i == null ? void 0 : i.navButtonPreviousAriaLabel,
        colorTheme: "dark",
        disabled: !a && g,
        onClick: () => u(-1),
        shape: "square",
        size: "medium",
        variant: "primary",
        children: /* @__PURE__ */ r.jsx(T, { name: "chevron-left", size: "medium" })
      }
    ),
    /* @__PURE__ */ r.jsx(
      d,
      {
        iconOnly: !0,
        $direction: "next",
        $hidden: !a && l,
        ariaLabel: i == null ? void 0 : i.navButtonNextAriaLabel,
        colorTheme: "dark",
        disabled: !a && l,
        onClick: () => u(1),
        shape: "square",
        size: "medium",
        variant: "primary",
        children: /* @__PURE__ */ r.jsx(T, { name: "chevron-right", size: "medium" })
      }
    ),
    /* @__PURE__ */ r.jsxs(Q, { "aria-atomic": !0, "aria-live": "polite", id: "liveregion", children: [
      "Item ",
      m + 1,
      " of ",
      t.length,
      "."
    ] }),
    !p && /* @__PURE__ */ r.jsxs(F, { children: [
      /* @__PURE__ */ r.jsx(y, { type: "heading", variant: "03", children: n == null ? void 0 : n.title }),
      /* @__PURE__ */ r.jsx(y, { type: "body", variant: "expressive", children: n == null ? void 0 : n.caption })
    ] })
  ] }) });
};
export {
  mt as Variant3
};
